module.exports = __webpack_public_path__ + "static/media/tdbLogo.b86f4638.png";